import React from "react";

import useLeaveModel from "../../hooks/useLeaveModel";
import useLovense from "../../hooks/other/useLovense";
import useBroadcaster from "../../hooks/chat/useBroadcaster";
import useInitJanus from "../../hooks/chat/useInitJanus";
import useDetectFS from "../../hooks/chat/useDetectFS";
import useInitZoom from "../../hooks/useInitZoom";

export default function CurrentModelInfo() {
  useLeaveModel();
  useLovense();
  useBroadcaster();
  useInitJanus();
  useDetectFS();
  useInitZoom();

  return <></>;
}
